import { render } from "./Other_causes.vue?vue&type=template&id=5c134ed6"
import script from "./Other_causes.vue?vue&type=script&lang=js"
export * from "./Other_causes.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__